enum ProvidedServices {
  PricingService,
  GeoService,
  QuoteService,
}

export default ProvidedServices;
